"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Legend = void 0;
const React = __importStar(require("react"));
const font_color_1 = require("../lib/font-color");
const palette_1 = require("../lib/palette");
const Legend = (props) => {
    return React.createElement("div", { className: "legend box" }, props.parts.map(part => React.createElement("div", { className: "notification", key: part.id, style: {
            backgroundColor: `#${palette_1.palette[part.id]}`,
            color: font_color_1.fontColorFor(`#${palette_1.palette[part.id]}`)
        } },
        part.description,
        ": ",
        part.value,
        React.createElement("button", { className: "delete" }))));
};
exports.Legend = Legend;
